import Vue from 'vue'
import Router from "vue-router";
import { authHeader } from '../helpers/auth-header'
import Userauth from '../auth/index'
import { userService } from '../services';

import MainBody from '../components/body'
import MainAuth from '../components/auth'

import DashboardPage from '../pages/dashboard'
import AlertsPage from '../pages/alerts'
import AboutPage from '../pages/about'
import ContactPage from '../pages/contact'
import IndexPage from '../pages/index'
import WalletPage from '../pages/wallet'
import NotificationPage from '../pages/notification'
import SearchPage from '../pages/search'
import OrdersPage from '../pages/orders'
import OrdersDetailsPage from '../pages/orderDetails'
import ProfilePage from '../pages/profile'
import CheckoutPage from '../pages/checkout'
import ShopsView from '../pages/shops'
import OffersPage from '../pages/offers'
import VendorPage from '../pages/vendor'
import ShopPage from '../pages/shop'
import SetupPrefPage from '../pages/setupPref'
import RateShopPage from '../pages/rateshop'
import MyShopsPage from '../pages/myshops'
import ProductsPage from '../pages/products'
import ProductPage from '../pages/product'
import VisitsPage from '../pages/visits'
import ScanPage from '../pages/scan'
import CartPage from '../pages/cart'
import GiftsPage from '../pages/gifts'
import ReferPage from '../pages/refer'
import UserPage from '../pages/user'


import SigninPage from '../pages/signin'
import ThereturnPage from '../pages/thereturn'
import SignupPage from '../pages/signup'
import SetupPage from '../pages/setup'
import VerifyotpPage from '../pages/verifyotp'
import TrackerPage from '../pages/tracker'

// import { store } from '../store'

//
Vue.use(Router)

const routes = [
    { path: '', redirect: { name: 'index' }},
    { path: '/', redirect: { name: 'index' }},
    {
        path: '/',
        component: MainBody,
        children:[
            {
                path: 'home',
                name: 'home',
                component: DashboardPage,
                meta: {
                    title: 'Home | Dashboard',
                }
              },
              {
                path: 'index',
                name: 'index',
                component: IndexPage,
                meta: {
                    title: 'Home | Welcome',
                }
              },
              {
                path: 'about',
                name: 'about',
                component: AboutPage,
                meta: {
                    title: 'About | Shopnscan',
                }
              },
              
              {
                path: 'contact',
                name: 'contact',
                component: ContactPage,
                meta: {
                    title: 'Contact | Shopnscan',
                }
              },
              {
                  path: 'search',
                  name: 'search',
                  component: SearchPage,
                  meta: {
                      title: 'Search',
                  }
              },
              {
                  path: 'orders',
                  name: 'orders',
                  component: OrdersPage,
                  meta: {
                      title: 'Orders',
                  }
              },
              {
                path: 'checkout',
                name: 'checkout',
                component: CheckoutPage,
                meta: {
                    title: 'Checkout',
                }
              },
              {
                path: 'cart',
                name: 'cart',
                component: CartPage,
                meta: {
                    title: 'Cart',
                }
              },
              {
                path: 'gifts',
                name: 'gifts',
                component: GiftsPage,
                meta: {
                    title: 'Gifts',
                }
              },
              {
                path: 'shops',
                name: 'shops',
                component: ShopsView,
                meta: {
                    title: 'Shops',
                }
             },
             {
                path: 'offers',
                name: 'offers',
                component: OffersPage,
                meta: {
                    title: 'Offers',
                }
             },
             {
               path: 'products',
               name: 'products',
               component: ProductsPage,
               meta: {
                   title: 'Products',
               }
             },
             {
               path: 'products/:shopName',
               name: 'products-shop',
               component: ProductsPage,
               meta: {
                   title: 'Products',
               }
             },
             {
                path: 'product',
                name: 'product',
                component: ProductPage,
                meta: {
                    title: 'Product',
                }
              },
              {
                path: 'product/:productName',
                name: 'product-productname',
                component: ProductPage,
                meta: {
                    title: 'Product',
                }
              },
             {
                path: 'vendor',
                name: 'vendor',
                component: VendorPage,
                meta: {
                    title: 'Vendor',
                }
             },
             {
                path: 'shop',
                name: 'shop',
                component: ShopPage,
                meta: {
                    title: 'Shops',
                }
             },
             {
                path: 'shop/:shopName',
                name: 'shop-shopname',
                component: ShopPage,
                meta: {
                    title: 'Shops',
                }
             },
             {
                path: 'setuppref',
                name: 'setuppref',
                component: SetupPrefPage,
                meta: {
                    title: 'Setup Preference',
                }
             },
             {
                path: 'rateshop',
                name: 'rateshop',
                component: RateShopPage,
                meta: {
                    title: 'Rate shop',
                }
             },
             {
                path: 'visits',
                name: 'visits',
                component: VisitsPage,
                meta: {
                    title: 'Visits',
                }
             },
             {
                path: 'scan',
                name: 'scan',
                component: ScanPage,
                meta: {
                    title: 'Scan',
                }
             },
             {
                path: 'myshops',
                name: 'myshops',
                component: MyShopsPage,
                meta: {
                    title: 'My Shops',
                }
             },
             {
                path: 'alerts',
                name: 'alerts',
                component: AlertsPage,
                meta: {
                    title: 'Alerts',
                }
              },
              {
                path: 'profile',
                name: 'profile',
                component: ProfilePage,
                meta: {
                    title: 'Profile',
                }
              },
              {
                path: 'notification',
                name: 'notification',
                component: NotificationPage,
                meta: {
                    title: 'Notification',
                }
            },
            {
                path: 'tracker',
                name: 'tracker',
                component: TrackerPage,
                meta: {
                    title: 'Tracker',
                }
            },
            {
                path: 'orderdetails',
                name: 'orderdetails',
                component: OrdersDetailsPage,
                meta: {
                    title: 'Order Details',
                }
            },
            {
                path: 'user',
                name: 'user',
                component: UserPage,
                meta: {
                    title: 'User ',
                }
            },
            
        ]
    },
    {
        path: '/',
        component: MainAuth,
        children: [
            {
                path: 'signin',
                name: 'signin',
                component: SigninPage,
                meta: {
                    title: 'Signin Here',
                }
            },
            {
                path: 'tr',
                name: 'tr',
                component: ThereturnPage,
                meta: {
                    title: 'The Return Signin',
                }
            },
            {
                path: 'thereturn',
                name: 'thereturn',
                component: ThereturnPage,
                meta: {
                    title: 'The Return Signin',
                }
            },
            {
                path: 'signup',
                name: 'signup',
                component: SignupPage,
                meta: {
                    title: 'Signup Here',
                }
            },
            {
                path: 'setup',
                name: 'setup',
                component: SetupPage,
                meta: {
                    title: 'Setup Here',
                }
            },
            {
                path: 'verifyotp',
                name: 'verifyotp',
                component: VerifyotpPage,
                meta: {
                    title: 'verify OTP Here',
                }
            },
            {
                path: 'refer',
                name: 'refer',
                component: ReferPage,
                meta: {
                    title: 'Refer ',
                }
            },
            {
                path: 'refer/:name/:referLink',
                name: 'refer-link',
                component: ReferPage,
                meta: {
                    title: 'Refer ',
                }
            }
        ]
    }
]



 //
//  axios.get('/getAll').then(res=>{
//     console.log(res.data)
//  })

const router = new Router({
    base: '/',
    mode: 'history',
    routes,
    linkActiveClass: "active",
    scrollBehavior () {
      return { x: 0, y: 0 }
    }
})


// const axios = require('axios')

// token
// let token = authHeader()['Authorization']

// console.log(token)

// authenticate 
router.beforeEach((to, from, next) => {

    let _to = to.path.split('/').length > 2 ? "/"+to.path.split('/')[1] : to.path

    // default routes without token
    if (['/signin', '/tr', '/thereturn', '/verifyotp', '/refer', '/setup'].includes(_to)){
        return next();
    } else {
        // user
        const User = localStorage.getItem('user')
        // check for token and token expiry
        if (['/signin', '/tr', '/thereturn','/setup', '/refer', 'verifyotp'].includes(to.path) || (User && Userauth.isAuthenticated()) ){
            return next();
        } else {
            // token has expired

            // user
            const User = JSON.parse(localStorage.getItem('user'))
            // validate
            if (!User) {
                // grab query and pass to next route
                return next({
                    path: '/signin',
                    query:  to.query
                })
            }
            // initiate a refresh request
            userService.refresh(User.refresh_token).then(res=>{
                //
                if (['/signin', '/tr','/thereturn','/setup', '/refer', 'verifyotp'].includes(to.path) || (User && Userauth.isAuthenticated())) {
                    return next();
                }

            }).catch(error=>{
                //
                Userauth.logout()
                //
                return next({
                    path: '/signin',
                    query:  to.query
                })
             })

        }

        if(to.meta.title)
            document.title = to.meta.title;

        // return next('/login')
    }

  
      
})

export default router